import {filter, isEmpty, some} from 'lodash';
import {useState} from 'react';

import './index.scss';
import Loading from 'components/Loading';
import InlinePage from 'components/Page/Inline';
import KyError from 'components/errors/KyError';
import InfoLink from 'components/links/Info';
import CuratorOnly from 'components/shared/curator_only';
import FullFluidWidthTemplate from 'components/templates/FullFluidWidth';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';
import LabelAnnotationsBarChart from 'pages/LabelAnnotations/BarChart';
import LabelAnnotationDrugTable from 'pages/LabelAnnotations/DrugTable';

export default function LabelAnnotationsPage() {
  const appContext = useAppContext();

  const {response, error} = useGet('site/labelsByDrug', {
    cacheResponse: !appContext.isPreview,
  });

  const [pgxLevelFilter, setPgxLevelFilter] = useState(null);
  const [showAllLabels, setShowAllLabels] = useState(false);

  let table = <Loading />;
  let barChart = (
    <div className="laFigure laFigure--loading figure figure--floatRight">
      <Loading />
    </div>
  );
  if (error) {
    table = <KyError kyError={error} />;
  } else if (response) {
    const {data} = response;
    table = (
      <LabelAnnotationDrugTable
        data={filter(data, (drug) => isFromTopSource(drug) || showAllLabels)}
        updatedFilters={pgxLevelFilter}
        showAllLabels={showAllLabels}
      />
    );
    barChart = (
      <LabelAnnotationsBarChart
        labelAnnotations={filter(data, (drug) => isFromTopSource(drug) || showAllLabels)}
        filterChangeFn={setPgxLevelFilter}
        showSwissMedicAndPMDALabels={showAllLabels}
        className="figure--floatRight"
      />
    );
  }

  return (
    <FullFluidWidthTemplate className="labelAnnotationsPage" title="Drug Label Annotations">
      <div className="container mb-3 clearfix">
        {barChart}
        <InlinePage id="drugLabelListingHeader" />
        {toggleSwissmedicAndPMDALabels(setShowAllLabels)}
      </div>

      <CuratorOnly>
        <a href="/edit/labelAnnotations">Curation Dashboard: List All Label Annotations</a>
      </CuratorOnly>

      {table}
    </FullFluidWidthTemplate>
  );
}

function toggleSwissmedicAndPMDALabels(setShowAllLabels) {
  const changeHandler = (e) => setShowAllLabels(e.target.checked);
  return (
    <label htmlFor="toggleSources" className="mt-2">
      <input id="toggleSources" type="checkbox" onChange={changeHandler} />
      <strong>{' '}Show all sources including Swissmedic and PMDA</strong>
      <InfoLink
        href="/page/drugLabelLegend#drug-label-collaborations"
        iconClassName="icon--superscript"
        iconSize="xs"
        newTab={true}
      />
    </label>
  );
}

const topLevelSources = ['FDA', 'EMA', 'HCSC'];

export function isFromTopSource(obj) {
  if (!Object.prototype.hasOwnProperty.call(obj, 'labels')) {
    return false;
  }
  const sources = Object.keys(obj.labels);
  return some(sources, (source) => topLevelSources.includes(source) && !isEmpty(obj.labels[source]));
}
